import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=c15ef206&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&id=c15ef206&prod&lang=scss"
import style1 from "./BottomNavBar.vue?vue&type=style&index=1&id=c15ef206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15ef206",
  null
  
)

export default component.exports